module.exports = __webpack_public_path__ + "static/media/bg-mob-4.5197a9a4.jpg";